import { render, staticRenderFns } from "./ContextMenuHeaderIcon.vue?vue&type=template&id=ec7cae86&scoped=true&"
import script from "./ContextMenuHeaderIcon.vue?vue&type=script&lang=js&"
export * from "./ContextMenuHeaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7cae86",
  null
  
)

export default component.exports